import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import React, { useMemo } from 'react';
import allCountries from 'country-region-data/data.json';
import { collect } from 'collect.js';
import useRegions from '../../../hooks/data/useRegions';

/**
 * Offers the countries the platform has a region for, unless the caller passes its own
 * `allowedCodes` (an array, or `'*'` for every country). A stored value outside the list
 * stays selectable, so an older record still shows its country's name.
 */
export default function CountrySelect({ value, onChange, allowedCodes = undefined, ...rest }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Form:Address:CountrySelect' });
  const { countries, loaded } = useRegions();
  const codes = allowedCodes ?? countries;

  const countryOptions = useMemo(
    () =>
      collect(allCountries)
        .filter(
          (item) => !Array.isArray(codes) || codes.includes(item.countryShortCode) || item.countryShortCode === value,
        )
        .map((item) => ({ label: item.countryName, value: item.countryShortCode }))
        .toArray(),
    [codes, value],
  );

  return (
    <Select
      value={value}
      options={countryOptions}
      onChange={onChange}
      loading={allowedCodes === undefined && !loaded}
      showSearch={{ optionFilterProp: 'label' }}
      placeholder={t('form.country.placeholder')}
      aria-autocomplete="none"
      autocomplete="none"
      {...rest}
    />
  );
}
